export default {
    allRightsReserved:'Todos os direitos reservados',
}